module.exports = __webpack_public_path__ + "static/media/429501428_778320764167231_3519070297938853213_n.c4ebd7a0.jpg";